import React, { useEffect } from 'react';
import { Card, Col, Row, Avatar, Tag } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { connect } from 'dva';
import moment from 'moment';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { MAP_API_KEY } from '../../../utils/constants';

// Reusable detail row
const DetailRow = ({ label, value }) => (
    <Row style={{ marginBottom: '0.75rem' }} gutter={[8, 8]}>
        <Col xs={12} sm={8} md={6}>
            <span style={{ color: '#666', fontWeight: '700' }}>{label}</span>
        </Col>
        <Col xs={12} sm={16} md={18}>
            <span style={{ color: '#333' }}>{value || '-'}</span>
        </Col>
    </Row>
);

const StoreView = props => {
    const { stores } = props;
    const { detail } = stores;
    const isApprove = props.location.search === "?redirect=approve";

    let latLng = { lat: 26.896592, lng: 75.770674 };
    if (detail?.latitude && detail?.longitude) {
        latLng = { lat: detail.latitude, lng: detail.longitude };
    }

    useEffect(() => {
        props.dispatch({ type: 'stores/getDetail', payload: { id: props.match.params.id } });
    }, []);

    return (
        <>
            <style>{`
                .store-view-card .ant-card-body { padding: 20px; }
                .store-images-grid {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 10px;
                    padding: 16px 0;
                }
                .store-images-grid .ant-avatar {
                    width: 120px !important;
                    height: 120px !important;
                    border-radius: 8px !important;
                    border: 1px solid #eee;
                    flex-shrink: 0;
                }
                .store-images-grid .ant-avatar img {
                    width: 100% !important;
                    height: 100% !important;
                    object-fit: cover !important;
                }
                .section-divider {
                    border-top: 1px solid #f0f0f0;
                    margin: 16px 0;
                }
                .section-title {
                    color: #999;
                    font-size: 12px;
                    font-weight: 700;
                    margin-bottom: 8px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }
                @media (max-width: 576px) {
                    .store-images-grid .ant-avatar {
                        width: 90px !important;
                        height: 90px !important;
                    }
                }
            `}</style>

            <Card
                className="store-view-card"
                title={
                    <span>
                        <LeftOutlined
                            onClick={() => props.history.push(isApprove ? '/approve' : '/stores')}
                            style={{ marginRight: 8, cursor: 'pointer' }}
                        />
                        Store Detail
                    </span>
                }
                style={{ marginTop: 0 }}
            >
                {/* ── Store Images ── */}
                <div className="store-images-grid">
                    {detail?.images?.length > 0
                        ? detail.images.map((img, index) => (
                            <Avatar
                                key={index}
                                shape="square"
                                size={120}
                                src={img.url}
                            />
                        ))
                        : <Avatar shape="square" size={120} />
                    }
                </div>

                <div className="section-divider" />

                {/* ── Owner Info ── */}
                <p className="section-title">Owner Info</p>
                <DetailRow label="Email" value={detail?.user_id?.email} />
                <DetailRow label="Mobile Number" value={detail?.user_id?.mobile_number} />

                <div className="section-divider" />

                {/* ── Store Info ── */}
                <p className="section-title">Store Info</p>
                <DetailRow label="Store Name" value={detail?.title} />
                <DetailRow label="Store Category" value={detail?.store_category} />
                <DetailRow
                    label="Store Cuisine"
                    value={
                        detail?.cuisine?.length > 0
                            ? detail.cuisine.map((val, i) => (
                                <Tag key={i} color="orange" style={{ marginBottom: 4 }}>{val}</Tag>
                            ))
                            : '-'
                    }
                />

                {/* ── Open Time — keep original logic ── */}
                {/* <Row style={{ marginBottom: '0.75rem' }} gutter={[8, 8]}>
                    <Col xs={12} sm={8} md={6}>
                        <span style={{ color: '#666', fontWeight: '700' }}>Store Open Time</span>
                    </Col>
                    <Col xs={12} sm={16} md={18}>
                        {detail && detail?.open_time ?
                            (() => {
                                const timeMoment = typeof detail.open_time === 'string' ?
                                    moment(detail.open_time, 'HH:mm') :
                                    moment(detail.open_time);
                                return timeMoment.isValid() ? timeMoment.format("hh:mm a") : '-';
                            })() : '-'}
                    </Col>
                </Row> */}
                <Row style={{ marginBottom: '0.75rem' }} gutter={[8, 8]}>
  <Col xs={12} sm={8} md={6}>
    <span style={{ color: '#666', fontWeight: '700' }}>
      Store Open Time
    </span>
  </Col>
  <Col xs={12} sm={16} md={18}>
    {detail?.open_time
      ? (() => {
          let m;

          if (typeof detail.open_time === 'string' && detail.open_time.includes('T')) {
            // ✅ ISO → convert UTC to local
            m = moment.utc(detail.open_time).local();
          } else {
            // ✅ HH:mm
            m = moment(detail.open_time, 'HH:mm');
          }

          return m.isValid() ? m.format("hh:mm a") : '-';
        })()
      : '-'}
  </Col>
</Row>

                {/* ── Close Time — keep original logic ── */}
                {/* <Row style={{ marginBottom: '0.75rem' }} gutter={[8, 8]}>
                    <Col xs={12} sm={8} md={6}>
                        <span style={{ color: '#666', fontWeight: '700' }}>Store Close Time</span>
                    </Col>
                    <Col xs={12} sm={16} md={18}>
                        {detail && detail?.close_time ?
                            (() => {
                                const timeMoment = typeof detail.close_time === 'string' ?
                                    moment(detail.close_time, 'HH:mm') :
                                    moment(detail.close_time);
                                return timeMoment.isValid() ? timeMoment.format("hh:mm a") : '-';
                            })() : '-'}
                    </Col>
                </Row> */}
<Row style={{ marginBottom: '0.75rem' }} gutter={[8, 8]}>
  <Col xs={12} sm={8} md={6}>
    <span style={{ color: '#666', fontWeight: '700' }}>
      Store Close Time
    </span>
  </Col>
  <Col xs={12} sm={16} md={18}>
    {detail?.close_time
      ? (() => {
          let m;

          if (typeof detail.close_time === 'string' && detail.close_time.includes('T')) {
            m = moment.utc(detail.close_time).local();
          } else {
            m = moment(detail.close_time, 'HH:mm');
          }

          return m.isValid() ? m.format("hh:mm a") : '-';
        })()
      : '-'}
  </Col>
</Row>
                <DetailRow label="Store Description" value={detail?.description} />

                <div className="section-divider" />

                {/* ── Location Info ── */}
                <p className="section-title">Location Info</p>
                <DetailRow label="Store Address" value={detail?.address} />
                <DetailRow label="City" value={detail?.city} />
                <DetailRow label="State" value={detail?.state} />
                <DetailRow label="Postal" value={detail?.postal} />

                <div className="section-divider" />

                {/* ── Other Info ── */}
                <p className="section-title">Other Info</p>
                <DetailRow
                    label="Status"
                    value={
                        detail?.status
                            ? <span style={{ color: 'green', fontWeight: 600 }}>✅ Published</span>
                            : <span style={{ color: 'red', fontWeight: 600 }}>❌ Unpublished</span>
                    }
                />
                <DetailRow
                    label="Approved"
                    value={
                        detail?.is_approve
                            ? <span style={{ color: 'green', fontWeight: 600 }}>✅ Approved</span>
                            : <span style={{ color: 'orange', fontWeight: 600 }}>⏳ Pending Approval</span>
                    }
                />

                {/* ── Created At — keep original ── */}
                <Row style={{ marginBottom: '0.75rem' }} gutter={[8, 8]}>
                    <Col xs={12} sm={8} md={6}>
                        <span style={{ color: '#666', fontWeight: '700' }}>Created At</span>
                    </Col>
                    <Col xs={12} sm={16} md={18}>
                        {detail && detail?.created_at}
                    </Col>
                </Row>

                <div className="section-divider" />

                {/* ── Map ── */}
                <p className="section-title">Location on Map</p>
                <Row gutter={15} style={{ height: 400, width: '100%', marginBottom: 16 }}>
                    <Col xs={24} sm={24} md={24}>
                        <LoadScript googleMapsApiKey={MAP_API_KEY} libraries={['places']}>
                            <GoogleMap
                                center={latLng}
                                zoom={15}
                                mapContainerStyle={{ width: '100%', height: '100%', borderRadius: 8 }}
                            >
                                <Marker position={latLng} />
                            </GoogleMap>
                        </LoadScript>
                    </Col>
                </Row>

            </Card>
        </>
    );
};

export default connect(({ stores }) => ({
    stores,
}))(StoreView);